<template>
  <div>
    <PageAllow controller="FinanceBills" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                :radios="datetimeRadios"
                show-radios
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 批量导出 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("financeBills.export") }}
              </v-btn>
              <!-- 批量修改 -->
              <v-btn
                v-if="pageType == 101"
                small
                color="primary"
                dark
                class="ms-1"
                @click.stop="batchEdit()"
              >
                {{ $t("financeBills.batch_edit") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="finance_bill_code"
                    v-model="options.finance_bill_code"
                    @text="financeBillCodeKyeWord = $event"
                    :label="$t('financeBills.Fields.finance_bill_code')"
                  />
                </v-col>
                <!-- 对象 -->
                <v-col cols="12" sm="6" md="4" v-if="pageType == 101 || pageType == 102">
                  <SearcherShops
                    v-if="settings && settings.shop_count < 1000"
                    v-model="shopsSelected"
                    :label="$t('financeBills.Fields.name')"
                  />
                  <SearcherKeyword
                    v-else
                    ref="shopKeyword"
                    v-model="options.shop_keyword"
                    @text="shopKeyword = $event"
                    :label="$t('Shop.shopsKeyword', [$consts.shopName()])"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" v-else-if="pageType == 201 || pageType == 202 || pageType == 203">
                  <SearcherSuppliers
                    v-model="supplierSelected"
                    :label="$t('financeBills.Fields.name')"
                  />
                </v-col>
                <!-- 仓库 -->
                <v-col cols="12" sm="6" md="4" v-else-if="pageType == 301 || pageType == 302">
                  <SearcherStocks v-model="stocksSelected" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="bill_code"
                    v-model="options.bill_code"
                    @text="billCodeKyeWord = $event"
                    :label="$t('financeBills.Fields.bill_code')"
                  />
                </v-col>
                <!-- 要货单号 -->
                <v-col cols="12" sm="6" md="4" v-if="pageType == 101 || pageType == 102">
                  <SearcherKeyword
                    ref="order_code"
                    v-model="options.order_code"
                    @text="orderCodeKyeWord = $event"
                    :label="pageType == 101 ? $t('financeBills.Fields.order_code') : $t('financeBills.Fields.return_order_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" v-else-if="pageType">
                  <SearcherKeyword
                    ref="org_code"
                    v-model="options.org_code"
                    @text="orgCodeKyeWord = $event"
                    :label="(pageType == 301 || pageType == 302)
                    ? $t('financeBills.Fields.requisition_code')
                    : pageType == 201
                      ? $t('financeBills.Fields.org_code')
                      : $t('financeBills.Fields.return_org_code')
                    "
                  />
                </v-col>
                <!-- 组别 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistrictsWithDescendants v-model="DistrictsSelected" />
                </v-col>
                <!-- 仓库 -->
                <v-col cols="12" sm="6" md="4" v-if="pageType == 201 || pageType == 202 || pageType == 203">
                  <SearcherStocks v-model="stocksSelected" />
                </v-col>
                <!-- 财务状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('financeBills.payFlgs.title')"
                    :items="$consts.financeFlgs"
                    v-model="options.pay_flgs"
                  />
                </v-col>
                <!-- 对账状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('financeBills.billCheckFlg.title')"
                    :items="$consts.billCheckFlg"
                    v-model="options.bill_check_flgs"
                  />
                </v-col>
                <!-- 归账状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('financeBills.billStatus.title')"
                    :items="$consts.billFlgs"
                    v-model="options.bill_status"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="pageType == 102">
                  <SearcherStatus
                    v-model="options.return_types"
                    :label="$t('ReturnOrder.Fields.type')"
                    :items="$consts.return_order.type"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            v-model="showSelected"
            :headers="headers"
            :items="finance_bills"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            show-select
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.order_code="{ header }">
              <span v-if="pageType == 101">
                {{ header.text }}
              </span>
              <span v-else-if="pageType == 102">
                {{ $t("financeBills.Fields.return_order_code") }}
              </span>
              <span v-else-if="pageType == 201">
                {{ $t("financeBills.Fields.org_code") }}
              </span>
              <span v-else-if="pageType == 202">
                {{ $t("financeBills.Fields.return_org_code") }}
              </span>
              <span v-else-if="pageType == 203">
                {{ $t("financeBills.Fields.return_purchase_code") }}
              </span>
              <span v-else-if="pageType == 301 || pageType == 302">
                {{ $t("financeBills.Fields.requisition_code") }}
              </span>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.return_type="{ item }">
              <v-chip
                small
                label
                :color="item.return_type | returnOrderTypesColor"
                :text-color="item.return_type | returnOrderTypesTextColor"
              >{{ item.return_type | returnOrderTypesText }}
              </v-chip>
            </template>
            <template v-slot:item.finance_bill_code="{ item }">
              <span>
                {{ item.finance_bill_code }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
              {{ item.created | formatTime }}
            </span>
            </template>
            <template v-slot:item.bill.bill_code="{ item }">
              <a
                style="text-decoration: none"
                :href="'/#/receipts/' + item.bill.id + '?time_type=1'"
              >
                {{ item.bill.bill_code }}
              </a>
            </template>
            <template v-slot:item.order_code="{ item }">
              <a
                v-if="item.bill.bill_type == 101"
                style="text-decoration: none"
                :href="'/#/orders/' + item.bill.org_id"
              >
                {{ item.bill.org_code }}
              </a>
              <a
                v-if="item.bill.bill_type == 102"
                style="text-decoration: none"
                :href="'/#/return-orders/' + item.bill.org_id"
              >
                {{ item.bill.org_code }}
              </a>
              <a
                v-if="item.bill.bill_type == 201"
                style="text-decoration: none"
                :href="'/#/stock-orders-in/' + item.bill.org_id"
              >
                {{ item.bill.org_code }}
              </a>
              <a
                v-if="item.bill.bill_type == 202"
                style="text-decoration: none"
                :href="'/#/stock-orders-out/' + item.bill.org_id"
              >
                {{ item.bill.org_code }}
              </a>
              <a
                  v-if="item.bill.bill_type == 203"
                  style="text-decoration: none"
                  :href="'/#/return-purchases/' + item.bill.org_id"
              >
                {{ item.bill.org_code }}
              </a>
              <a
                  v-if="item.bill.bill_type == 301 || item.bill.bill_type == 302"
                  style="text-decoration: none"
                  :href="'/#/requisitions/' + item.bill.org_id"
              >
                {{ item.bill.org_code }}
              </a>
            </template>
            <template v-slot:item.shop_name="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{
                    (item.bill.bill_type == 101 || item.bill.bill_type == 102)
                      ? item.shop.shop_name
                      : (item.bill.bill_type == 301 || item.bill.bill_type == 302)
                        ? item.stock.name
                            : item.supplier.supplier_name
                }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{
                  (item.bill.bill_type == 101 || item.bill.bill_type == 102)
                      ? item.shop.shop_code
                      : (item.bill.bill_type == 301 || item.bill.bill_type == 302)
                          ? item.stock.code
                          : item.supplier.supplier_code
                }}
              </span>
            </template>

            <template v-slot:item.fee="{ item }">
              {{ $t("Global.money") }}
              {{ item.fee | formatMoney }}
            </template>

            <template v-slot:item.bill_check_flg="{ item }">
              <v-chip
                small
                label
                :color="item.bill.bill_check_flg | billCheckFlgColor"
                :text-color="item.bill.bill_check_flg | billCheckFlgTextColor"
              >
                {{ item.bill.bill_check_flg | billCheckFlgText }}
              </v-chip>
            </template>

            <template v-slot:item.pay_flg="{ item }">
              <v-chip
                small
                label
                :color="item.bill.pay_flg | financeFlgsColor"
                :text-color="item.bill.pay_flg | financeFlgsTextColor"
              >
                {{ item.bill.pay_flg | financeFlgsText }}
              </v-chip>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                label
                :color="item.bill.status | billFlgsColor"
                :text-color="item.bill.status | billFlgsTextColor"
              >
                {{ item.bill.status | billFlgsText }}
              </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip
                top
                v-if="$permission.permissionAllow('FinanceBills', 'view')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                    class="px-2 me-2 mb-1"
                    :href="'/#' + $route.path + '/' + item.id"
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("financeBills.details") }}
                  </v-btn>
                </template>
                <span>{{ $t("financeBills.details") }}</span>
              </v-tooltip>

              <!-- Edit -->
              <v-tooltip
                top
                v-if="
                  $permission.permissionAllow('FinanceBills', 'edit') &&
                  item.bill.status == 1
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                    color="action"
                    class="px-2 me-2 mb-1"
                    :href="
                      '/#' + $route.path + '/edit/' +
                      item.id +
                      '?financeBillCode=' +
                      item.finance_bill_code
                    "
                  >
                    <!-- <v-icon x-small class="pe-1">fa-align-left</v-icon> -->
                    {{ $t("financeBills.edit") }}
                  </v-btn>
                </template>
                <span>{{ $t("financeBills.edit") }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import FinanceBills from "@/api/finance_bills";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherSuppliers from "@/components/plugins/SearcherSuppliers";
import SearcherStocks from "@/components/plugins/SearcherStocks";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  org_time_from: "",
  org_time_to: "",
  district_ids: [],
  pay_flgs: [1, 2, 3],
  bill_check_flgs: [0, 1],
  bill_status: [0, 1],
  finance_bill_code: "",
  bill_code: "",
  order_code: "",
  org_code: "",
  shop_ids: [],
  supplier_ids: [],
  return_types:[1, 2, 3],
  shop_keyword: "",
};

const defaultPurchaseOptions = {
  datetimeRadioSelected: "org",
  created_time_from: "",
  created_time_to: "",
  org_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  org_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  bill_created_time_from: "",
  bill_created_time_to: "",
  district_ids: [],
  pay_flgs: [1, 2, 3],
  bill_check_flgs: [0, 1],
  bill_status: [0, 1],
  finance_bill_code: "",
  bill_code: "",
  order_code: "",
  org_code: "",
  shop_ids: [],
  supplier_ids: [],
  stock_ids: [],
};

const defaultReturnPurchaseOptions = {
  datetimeRadioSelected: "bill_created",
  bill_created_time_from:  new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  bill_created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  district_ids: [],
  pay_flgs: [1, 2, 3],
  bill_check_flgs: [0, 1],
  bill_status: [0, 1],
  finance_bill_code: "",
  bill_code: "",
  order_code: "",
  org_code: "",
  shop_ids: [],
  supplier_ids: [],
  stock_ids: [],
};

const defaultStockOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
      new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  org_time_from: "",
  org_time_to: "",
  bill_created_time_from: "",
  bill_created_time_to: "",
  district_ids: [],
  pay_flgs: [1, 2, 3],
  bill_check_flgs: [0, 1],
  bill_status: [0, 1],
  finance_bill_code: "",
  bill_code: "",
  order_code: "",
  org_code: "",
  shop_ids: [],
  supplier_ids: [],
  stock_ids: [],
};

function getPageType() {
  let urlParts = document.URL.split('/');
  urlParts = urlParts[urlParts.length - 1]
  switch (urlParts) {
    default:
    case "finance-bills-order":
      return 101;
    case "finance-bills-return":
      return 102;
    case "finance-bills-purchase":
      return 201;
    case "finance-bills-purchaseReturn":
      return 202;
    case "finance-bills-returnPurchase":
      return 203;
    case "finance-bills-requisition":
      return 301;
    case "finance-bills-requisitionPay":
      return 302;
  }
}

function getOptionPrefix() {
  switch (getPageType()) {
    default:
    case 101:
      return "finance-bills-order";
    case 102:
      return "finance-bills-return";
    case 201:
      return "finance-bills-purchase";
    case 202:
      return "finance-bills-purchaseReturn";
    case 203:
      return "finance-bills-returnPurchase";
    case 301:
      return "finance-bills-requisition";
    case 302:
      return "finance-bills-requisitionPay";
  }
}

function getOptionSelects() {
  switch (getPageType()) {
    default:
    case 101:
    case 102:
      return [
        "DistrictsSelected",
        "shopsSelected",
        "supplierSelected",
      ];
    case 201:
    case 202:
    case 203:
      return [
        "DistrictsSelected",
        "shopsSelected",
        "supplierSelected",
        "stocksSelected"
      ];
    case 301:
    case 302:
      return [
        "DistrictsSelected",
        "stocksSelected"
      ];
  }
}

function getDefaultOptions() {
  switch (getPageType()) {
    default:
    case 101:
    case 102:
      return defaultOptions;
    case 201:
    case 202:
      return defaultPurchaseOptions;
    case 203:
      return defaultReturnPurchaseOptions;
    case 301:
    case 302:
      return defaultStockOptions;
  }
}

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem(getOptionPrefix() + "-options")
        ? sessionStorage.getItem(getOptionPrefix() + "-options")
        : JSON.stringify(getDefaultOptions())
    ),
    DistrictsSelected: [],
    paging: {},
    finance_bills: [],
    showSelected: [],
    financeBillType: 101,
    shopsSelected: [],
    supplierSelected: [],
    stocksSelected: [],
    pageType: getPageType(),
    shopKeyword: "",
  }),

  components: {
    SearcherStatus,
    SearcherDatetimeRangeWithRadio,
    SearcherDistrictsWithDescendants,
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherShops,
    SearcherSuppliers,
    SearcherStocks,
  },

  computed: {
    items() {
      let items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.inanceReceipt"),
          disabled: true,
          href: "/finance-receipt",
        },
      ];
      if (this.$route.path.startsWith("/finance-bills-order")) {
        items.push({
          text: i18n.t("Nav.financeBillForOrder"),
          disabled: true,
          href: "/finance-bills-order",
        });
      } else if(this.$route.path.startsWith("/finance-bills-returnPurchase")) {
        items.push({
          text: i18n.t("Nav.financeBillForReturnPurchase"),
          disabled: true,
          href: "/finance-bills-purchase",
        })
      } else if (this.$route.path.startsWith("/finance-bills-return")) {
        items.push({
          text: i18n.t("Nav.financeBillForReturn"),
          disabled: true,
          href: "/finance-bills-return",
        });
      } else if (this.$route.path.startsWith("/finance-bills-purchaseReturn")) {
        items.push({
          text: i18n.t("Nav.financeBillForPurchaseReturn"),
          disabled: true,
          href: "/finance-bills-purchaseReturn",
        });
      } else if (this.$route.path.startsWith("/finance-bills-purchase")) {
        items.push({
          text: i18n.t("Nav.financeBillForPurchase"),
          disabled: true,
          href: "/finance-bills-purchase",
        });
      } else if (this.$route.path.startsWith("/finance-bills-requisitionPay")) {
        items.push({
          text: i18n.t("Nav.financeBillForRequisitionPay"),
          disabled: true,
          href: "/finance-bills-requisitionPay",
        });
      } else if (this.$route.path.startsWith("/finance-bills-requisition")) {
        items.push({
          text: i18n.t("Nav.financeBillForRequisition"),
          disabled: true,
          href: "/finance-bills-requisition",
        });
      }
      return items
    },
    datetimeRadios() {
      let radios = [];
      if (this.$route.path.startsWith("/finance-bills-returnPurchase")) {
        return [{
          key: "bill_created",
          text: i18n.t("financeBills.created"),
        }];
      } else {
        if (this.$route.path.startsWith("/finance-bills-order") || this.$route.path.startsWith("/finance-bills-return") || this.$route.path.startsWith("/finance-bills-requisition")) {
          radios.push({
            key: "created",
            text: i18n.t("financeBills.time"),
          })
        }else {
          radios.push({
            key: "org",
            text: i18n.t("financeBills.time"),
          })
        }
        radios.push({
          key: "bill_created",
          text: i18n.t("financeBills.created_time"),
        })
        return radios;
      }
    },
    headers() {
      let headers = [
        {
          text: i18n.t("financeBills.Fields.finance_bill_code"),
          align: "start",
          sortable: false,
          value: "finance_bill_code",
        },
        {
          text: i18n.t("financeBills.Fields.bill_code"),
          align: "start",
          sortable: false,
          value: "bill.bill_code",
        },
        {
          text: i18n.t("financeBills.Fields.order_code"),
          align: "start",
          sortable: false,
          value: "order_code",
        },
        {
          text: i18n.t("financeBills.Fields.name"),
          align: "start",
          sortable: false,
          value: "shop_name",
        }
      ];
      if (this.pageType == 102) {
        headers.push(
          {
            text: i18n.t("ReturnOrder.Fields.type"),
            align: "center",
            class: "text-no-wrap",
            sortable: false,
            value: "return_type",
          })
      }
      headers.push(
        {
          text: i18n.t("financeBills.Fields.fee"),
          align: "end",
          sortable: false,
          value: "fee",
        },
        {
          text: i18n.t("financeBills.Fields.billCheckFlg"),
          align: "start",
          sortable: false,
          value: "bill_check_flg",
        },
        {
          text: i18n.t("financeBills.Fields.payFlgs"),
          align: "start",
          sortable: false,
          value: "pay_flg",
        },
        {
          text: i18n.t("financeBills.Fields.billStatus"),
          align: "start",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        })
      return headers;
    },
    optionPrefix() {
      return getOptionPrefix();
    },
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.resetPage()
  },

  methods: {
    onSearch() {
      this.options = Object.assign(this.options, {
        finance_bill_code: this.financeBillCodeKyeWord,
        bill_code: this.billCodeKyeWord,
        order_code: this.orderCodeKyeWord,
        org_code: this.orgCodeKyeWord,
        finance_bill_type: this.financeBillType,
        shop_keyword: this.shopKeyword,
      });
      this.getFinanceBillsFromAPI();
    },
    resetSearch() {
      this.DistrictsSelected = [];
      this.shopsSelected = [];
      this.supplierSelected = [];
      this.stocksSelected = [];
      this.options = JSON.parse(JSON.stringify(getDefaultOptions()));
      [this.$refs.finance_bill_code, this.$refs.shopKeyword, this.$refs.bill_code, this.$refs.order_code, this.$refs.org_code].forEach((k) => {
        if (k) k.clear();
      });
    },
    getFinanceBillsFromAPI() {
      if (this.pageType != 102) {
        delete this.options.return_types
      }
      if (this.pageType != 101 && this.pageType != 102) {
        delete this.options.shop_keyword
      }
      let data = Object.assign({}, this.options, {
        finance_bill_type: this.pageType,
      });
      FinanceBills.fetch(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.finance_bills = response.data.finance_bills;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    batchEdit() {
      if (this.showSelected.length) {
        var showSelectedIds = [];
        this.showSelected.map((e) => {
          showSelectedIds.push(e.id);
        });
        this.$router.push({
          path: this.$route.path + "/batch-edit",
          query: {
            financeBillIds: encodeURI(showSelectedIds),
          },
        });
      }
    },
    exportExcel() {
      let data = Object.assign({}, this.options, {
        finance_bill_type: this.pageType,
      });
      FinanceBills.exportExcel(data);
    },
    resetPage(){
      this.pageType = getPageType();
      this.$commonUtils.loadOptions(getOptionPrefix(), getOptionSelects()).then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "districtSelected":
                this.districtSelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
      if ((this.pageType == 101) || (this.pageType == 102)) {
        this.options.datetimeRadioSelected = "created";
        this.options.created_time_from = this.options.created_time_from ? this.options.created_time_from : this.options.org_time_from;
        this.options.created_time_to = this.options.created_time_to ? this.options.created_time_to : this.options.org_time_to;
        this.options.org_time_from = "";
        this.options.org_time_to = "";
        this.supplierSelected = [];
        this.stocksSelected = [];
      } else if ((this.pageType == 201) || (this.pageType == 202) || (this.pageType == 203)) {
        this.options.datetimeRadioSelected = "org";
        this.options.org_time_from = this.options.org_time_from ? this.options.org_time_from : this.options.created_time_from;
        this.options.org_time_to = this.options.org_time_to ? this.options.org_time_to : this.options.created_time_to;
        this.options.created_time_from = "";
        this.options.created_time_to = "";
        this.shopsSelected = [];
      } else if ((this.pageType == 301) || (this.pageType == 302)) {
        this.options.datetimeRadioSelected = "created";
        this.options.created_time_from = this.options.created_time_from ? this.options.created_time_from : this.options.org_time_from;
        this.options.created_time_to = this.options.created_time_to ? this.options.created_time_to : this.options.org_time_to;
        this.options.org_time_from = "";
        this.options.org_time_to = "";
        this.shopsSelected = [];
        this.supplierSelected = []
      }
    },
  },

  watch: {
    $route: {
      handler() {
        this.resetPage()
      },
    },
    options: {
      deep: true,
      handler() {
        if (getPageType() == 101 || getPageType() == 102) {
          this.options.org_code = null;
        } else if (getPageType() != 101 && getPageType() != 102) {
          this.options.order_code = null;
        }
        this.getFinanceBillsFromAPI();
        sessionStorage.setItem(
          getOptionPrefix() + "-options",
          JSON.stringify(this.options)
        );
      },
    },
    shopsSelected: {
      handler() {
        this.options.shop_ids =
          this.shopsSelected && this.shopsSelected.length
            ? this.shopsSelected.map((e) => {
                return e.id;
              })
            : [];
        sessionStorage.setItem(
          getOptionPrefix() + "-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    supplierSelected: {
      handler() {
        this.options.supplier_ids =
          this.supplierSelected && this.supplierSelected.length
            ? this.supplierSelected.map((e) => {
                return e.id;
              })
            : [];
        sessionStorage.setItem(
          getOptionPrefix() + "-supplierSelected",
          JSON.stringify(this.supplierSelected)
        );
      },
    },
    // 组别
    DistrictsSelected: {
      handler() {
        this.options.district_ids = this.DistrictsSelected
          ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          getOptionPrefix() + "-DistrictsSelected",
          JSON.stringify(this.DistrictsSelected)
        );
      },
    },
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          getOptionPrefix() + "-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    // 已选择 的 id  [  ]
    showSelected: {
      handler() {
        let showSelectedId = [];
        this.showSelected.map((e) => {
          showSelectedId.push(e.id);
        });
      },
    },
  },
};
</script>

<style>
</style>